import { Component } from '@angular/core';
import { EcitationReportService } from 'src/services/ecitation-report.service';
import * as XLSX from 'xlsx';
import { FileSaverService } from 'ngx-filesaver';
import { AlertService } from 'src/app/alert-notify/alert-notify.service';
@Component({
    selector: 'app-ecitation-agency-summary-report',
    templateUrl: './ecitation-agency-summary-report.component.html',
    styleUrls: ['./ecitation-agency-summary-report.component.css'],
    standalone: false
})
export class EcitationAgencySummaryReportComponent  {
  showReportResults = false;
  startdate='';
  enddate='';
  today ='';
  outPut: any = [];
  constructor(private ecitationReportService:EcitationReportService ,private fileSaverService: FileSaverService, public alertService: AlertService){
       const today = new Date();
    const day = String(today.getDate()).padStart(2,'0');
    const month = String(today.getMonth()+1).padStart(2,'0');
    const year = today.getFullYear();
    this.today = `${year}-${month}-${day}`;
  }
    pageSize:number = 25;
	currentPage:number =1;

	getItems(){
		const satrtIndex = (this.currentPage - 1) * this.pageSize;
		return this.outPut.slice(satrtIndex , satrtIndex + this.pageSize);
	}

	onPageChange(pageNumber:number){
		this.currentPage = pageNumber
	}

	getTotalPages():number{
		return Math.ceil(this.outPut.length / this.pageSize);
	}

	getVisiblePages():number[]{
		const totalVisiblePages = 10;
		const visiblePages:number[]=[];
		const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages/2));
		const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
		for(let i = startPage; i<=endPage; i++){
			visiblePages.push(i)
		}
		return visiblePages
	}
  generateReport() {
    // Check if both start date and end date are not selected
    if (!this.startdate && !this.enddate) {
      // Throw an error using AlertService
      this.alertService.error('Please select at least one date (Start Date or End Date) to generate the report.');
      return;
    }  
    // Proceed with the API call if dates are valid
    this.ecitationReportService
    .getAgencySummaryReport(this.startdate, this.enddate)
    .subscribe({
      next: (res) => {
       this.showReportResults = true;
       this.outPut = res;
       console.log(this.enddate, this.startdate);
      },
      error: (err) => {
       this.alertService.error('An error occurred while generating the report.');
      },
      complete: () => {
       console.log('Report generation completed.');
      },
    });
  }
  
  getCurrentPageTotal(){
    if(this.currentPage * 10 > this.outPut.length ){
     return this.outPut.length 
    } else{
      return this.currentPage * 10 
    }
  }
  excelExport() {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    const headers = ['Issued By','Queued','Rejected','Failed','DNR','DAIT-PROTECT','COWS','CCAP','MUNICIPAL COURT','NO ACTION','Total']
    const worksheet = XLSX.utils.json_to_sheet([],{header:headers})
    XLSX.utils.sheet_add_json(worksheet , this.outPut , {origin:'A2',skipHeader:true});
    const workbook = {
      Sheets: {
        'Agency-Summary-Report': worksheet
      },
      SheetNames: ['Agency-Summary-Report']
    }

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE })
    this.fileSaverService.save(blobData, `Agency-Summary-Report-${this.startdate}-${this.enddate}`)
  }
}
